export function setWidgetAssetBaseFromBundleScript() {
  ;(window as { __WIDGET_ASSET_BASE__?: string }).__WIDGET_ASSET_BASE__ = (() => {
    const script = document.querySelector(
      'script[src*="enrollment-app.js"], script[src*="enrollment-widget.js"]'
    ) as HTMLScriptElement | null

    if (!script) {
      return ''
    }

    try {
      return new URL(script.src).origin
    } catch {
      return ''
    }
  })()
}
